import paginator from '~/helpers/paginator';

export default {
  getAllPaginated: async (data = null) => await paginator.grabAllPages($nuxt.$api.hostV2 + '/application', {}, data),

  getAll: (data = null) =>
    $nuxt.$axios.get($nuxt.$api.hostV2 + '/application', data),

  getApplication: (application_uuid) => $nuxt.$axios.get($nuxt.$api.hostV2 + '/application/' + application_uuid),

  createApplication: (data = null) =>
    $nuxt.$axios.post($nuxt.$api.hostV2 + '/application', data),

  updateApplication: (application_uuid, data = null) =>
    $nuxt.$axios.put($nuxt.$api.hostV2 + '/application/' + application_uuid, data),

  generate: (application_uuid) => $nuxt.$axios.post(`${$nuxt.$api.hostV2}/application/${application_uuid}/generate`),
}
